/*eslint-disable*/
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Card,
  CardBody,
  Row,
  Container,
  CardImg,
} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleHeader from "components/Headers/SimpleHeader.js";

export default function IklanPage() {

  return (
    <>
      <SimpleHeader name="Iklan" parentName="Report" />
      
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
                <CardBody>
                    <Row>
                        <div className="card-columns">
                            <Card>
                                <Link to="/admin/iklan/master/iklan/page">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/iklan.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                            <Card>
                                <Link to="/admin/iklan/master/iklan/carousel-1/page">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/carousel-1.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                            <Card>
                                <Link to="/admin/iklan/master/iklan/carousel-2/page">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/carousel-2.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                            <Card>
                                <Link to="/admin/iklan/master/iklan/carousel-3/page">
                                    <CardImg
                                        alt="..."
                                        src={require("assets/img/theme/carousel-3.png").default}
                                        top
                                    />
                                </Link>
                            </Card>
                        </div>
					</Row>
                </CardBody>
          </div>
        </Row>
      </Container>
      
    </>
  );
}